export default __webpack_public_path__ + "static/media/404.ff9d81ca.jpg";